"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IBeaconUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _IBeaconUpgradeable__factory.IBeaconUpgradeable__factory;
  }
});

var _IBeaconUpgradeable__factory = require("./IBeaconUpgradeable__factory");